import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      zIndex: theme.zIndex.onboarding,

      '&[data-popper-reference-hidden]': {
        visibility: 'hidden',
      },
    },
  }),
  { name: 'LockedScorePopper' }
);
